import { ROLE_OPTIONS, RoleEnum } from '@/constant';
import { GetWorkerUserListResponse } from '@/services';

import { formatDate, map } from 'utils';

export const formatWorkerUserDetail = (
	input: GetWorkerUserListResponse['content'][number]
) => {
	return {
		...input,
		registDt: formatDate(input.registDt),
		updateDt: formatDate(input.updateDt),
		roleName: ROLE_OPTIONS?.find((role) => role.value === input.role)?.label,
		publicMainFranchiseId:
			input.role === RoleEnum.PUBLIC_ADMIN
				? input.publicMainFranchiseId
				: undefined,
	};
};

export const formatWorkerUserList = (
	input: GetWorkerUserListResponse['content']
) => {
	return map(input, formatWorkerUserDetail);
};
